export const companiesCompanyIdAppGroupPermissionSetsAllPermissionSets =
  "/companies/:company_id/app_group_permission_sets/all_permission_sets";
